import { z } from "zod";
import MealsApi from "@/packages/api/Api/V1/MealsApi";
import { jsonHeaders } from "@/packages/dashboard/csrf";
import { withAppDomain } from "@/packages/dashboard/utils/url-utils";

const mealItemPayloadSchema = z.object({
  meal_item_id: z.number().int().positive().optional(),
  food_item_id: z.number().int().positive(),
  quantity: z.number().positive(),
});

const addMealItemPayloadSchema = z.object({
  meal: z.object({
    timestamp: z.string().datetime(),
    meal_items: z.array(mealItemPayloadSchema).length(1),
  }),
});

const mealSchema = z.object({
  id: z.number().int().positive(),
  timestamp: z.string().datetime(),
});

const mealItemResponseSchema = z.object({
  id: z.number().int().positive(),
  meal_id: z.number().int().positive(),
  food_item_id: z.number().int().positive(),
  quantity: z.string().transform((value) => Number(value)),
});

const addMealItemResponseSchema = z.object({
  meal: mealSchema,
  meal_item: mealItemResponseSchema,
});

export type AddMealItemPayload = z.infer<typeof addMealItemPayloadSchema>;
export type AddMealItemResponse = z.infer<typeof addMealItemResponseSchema>;

export async function addMealItem(payload: AddMealItemPayload): Promise<AddMealItemResponse> {
  const body = addMealItemPayloadSchema.parse(payload);
  const response = await fetch(withAppDomain(MealsApi.addItem.path()), {
    method: "POST",
    headers: jsonHeaders(),
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorBody = await response.text();
    throw new Error(`Meal item add failed (${response.status}): ${errorBody}`);
  }

  const data = await response.json();
  return addMealItemResponseSchema.parse(data);
}
